export default __webpack_public_path__ + "static/media/wordImage.20f65e93.png";